import { truncateText } from '@/utils/strings';
import { colors } from 'components/src/foundation';
import { NextLink } from 'components/src/link';
import Close from 'components/src/svg/Close';
import { motion, AnimationProps } from 'framer-motion';
import { Paragraph, Subheading } from 'components/src/typography';
import React from 'react';
import { formatIcelandicDate } from '@/utils/dates';
import { getOr } from '@/utils/options';

interface Props {
  title: string;
  description: string;
  timeStamp?: string;
  status?: string;
  onClose: () => void;
}

const commonProps: AnimationProps = {
  initial: { x: '50vw' },
  animate: { x: 0 },
  exit: { opacity: 0 },
  transition: { duration: 0.3 },
};

const IncidentPopup = ({ title, description, timeStamp, onClose }: Props) => {
  return (
    <motion.div
      className="fixed right-32 top-128 z-[100]  w-[calc(100%-64px)] rounded-28 bg-white-100 p-24 shadow-lg sm:max-w-[554px]"
      {...commonProps}
    >
      <div className=" mb-16 flex flex-row items-center justify-between pl-24">
        <div className="title-lg text-red-100">Tilkynning</div>
        <button
          aria-label={'Close'}
          className="ml-4 flex h-40 w-40 items-center justify-center rounded-full bg-[#2c2d301e] p-8"
          onClick={onClose}
        >
          <Close color={colors.neutral[10]} />
        </button>
      </div>
      <div className="mb-2 pl-24">
        <div className="flex justify-between">
          <div className="flex flex-col">
            {timeStamp && <p className="body-lg">{formatIcelandicDate(getOr<string>(timeStamp, ''))}</p>}
            <Subheading classes="headline-lg mb-8 text-red-100">{title}</Subheading>
          </div>
        </div>
        <Paragraph classes="body-lg">{truncateText(description, 180)}</Paragraph>
      </div>
      <div className="mt-24 pl-24">
        <NextLink label="Skoða nánar" href={'/tilkynningar'} bold />
      </div>
    </motion.div>
  );
};

export default IncidentPopup;
